import { LayoutNameResolver, LogManager, StringUtil, ValueOrFunction, ValueResolver } from "@mcleod/core";
import { LayoutOpenedFrom } from "../components/layout/LayoutOpenedFrom";
import { LayoutProps } from "../components/layout/LayoutProps";
import { LayoutTabLauncher } from "./LayoutTabLauncher";

const log = LogManager.getLogger("components.page.ListLayoutLauncher");

export interface ListLayoutLauncherProps {
    listLayout: ValueOrFunction<string>;
    keyValues: ValueOrFunction<string[]>;
}

export class ListLayoutLauncher {

    /**
     * Opens a list layout in a new tab, searches for the specified value,
     * and automatically selects the matching table row.
     *
     * @param props - The props to pass to the list layout launcher
     */
    public static async open(props: ListLayoutLauncherProps) {
        try {
            const listLayout = LayoutNameResolver.resolve(props.listLayout);
            if (listLayout == null) {
                log.debug("Unable to resolve list layout: %s", props.listLayout);
                return null;
            }

            const keyValues = ValueResolver.resolve(props.keyValues)?.filter(value => !StringUtil.isEmptyString(value)) ?? [];
            const layoutProps: Partial<LayoutProps> = {
                openedFrom: LayoutOpenedFrom.LIST_LAUNCHER,
                drilldownKeyValues: keyValues
            };

            if (keyValues?.length > 1) {
                layoutProps.preventAutoSearchOnLoad = true;
            }

            await LayoutTabLauncher.open(listLayout, layoutProps);
        } catch (error) {
            log.error("Failed to navigate to list layout:", error);
            throw error;
        }
    }
}
